import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    //console.log('button');

    let button = this.element;
    let versions = document.getElementById('js-version-list');

    button.onclick = function () {
      //console.log('button');
      if (versions.style.display === "none") {
        versions.style.display = "block";
      } else {
        versions.style.display = "none";
      }
    }
  }
}